import { apiFetch } from "./client.ts";

export type SmsThreadStatus = "active" | "opted_out" | "blocked";
export type SmsDirection = "inbound" | "outbound";
export type SmsMessageStatus =
  | "queued"
  | "sending"
  | "sent"
  | "delivered"
  | "failed"
  | "undelivered"
  | "received";

export interface SmsThread {
  id: string;
  account_id: string;
  site_id: string | null;
  peer_e164: string;
  websquad_e164: string;
  status: SmsThreadStatus;
  client_id: string | null;
  last_message_at: string;
  last_message_preview: string | null;
  unread_count: number;
  opted_out_at: string | null;
}

export interface SmsThreadList {
  items: SmsThread[];
  total: number;
  limit: number;
  offset: number;
}

export interface SmsMessage {
  id: string;
  thread_id: string;
  direction: SmsDirection;
  status: SmsMessageStatus;
  twilio_sid: string | null;
  body: string;
  media_keys: unknown[] | null;
  error_code: string | null;
  error_message: string | null;
  sent_by_user_id: string | null;
  created_at: string;
  delivered_at: string | null;
}

export interface SmsMessageList {
  items: SmsMessage[];
  total: number;
}

export const listThreads = (params: { site_id?: string; q?: string; limit?: number; offset?: number } = {}) => {
  const usp = new URLSearchParams();
  if (params.site_id) usp.set("site_id", params.site_id);
  if (params.q) usp.set("q", params.q);
  usp.set("limit", String(params.limit ?? 50));
  usp.set("offset", String(params.offset ?? 0));
  return apiFetch<SmsThreadList>(`/sms/threads?${usp}`);
};

export const getThread = (id: string) => apiFetch<SmsThread>(`/sms/threads/${id}`);

export const listThreadMessages = (id: string, limit = 200) =>
  apiFetch<SmsMessageList>(`/sms/threads/${id}/messages?limit=${limit}`);

export const markThreadRead = (id: string) =>
  apiFetch<{ status: string }>(`/sms/threads/${id}/mark-read`, { method: "POST" });

export const sendSms = (payload: { site_id: string; peer_e164: string; body: string }) =>
  apiFetch<SmsMessage>(`/sms/send`, { method: "POST", body: JSON.stringify(payload) });
